var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccessfullSumbmit = function SvgSuccessfullSumbmit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 108,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.3,
    strokeWidth: 15.595,
    d: "M97.667 54.41v44.835H7.998V9.577h65.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#21DE1D",
    strokeWidth: 15.595,
    d: "m26.893 41.087 26.51 26.51L115.002 6"
  })));
};
export default SvgSuccessfullSumbmit;